import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from "@mui/material";
import noop from "lodash/noop";
import type { FC } from "react";

type Currency = "PLN" | "EUR";

interface CurrencyPickerProps {
  readonly label?: string;
  readonly value: Currency | null;
  readonly disabled?: boolean;
  readonly readonly?: boolean;
  readonly onChange: (value: Currency) => void;
}

const CurrencyPicker: FC<CurrencyPickerProps> = ({ label, value, disabled, readonly, onChange }) => (
  <FormControl>
    {label && <FormLabel id="currency-radio-buttons-group-label">{label}</FormLabel>}
    <RadioGroup
      name="waluta"
      aria-labelledby={label ? "currency-radio-buttons-group-label" : undefined}
      row
      value={value ?? ""}
      onChange={(e) => (readonly ? noop : onChange(e.target.value as Currency))}
    >
      {["PLN", "EUR"].map((v) => (
        <FormControlLabel key={v} label={v} value={v} control={<Radio />} disabled={disabled} />
      ))}
    </RadioGroup>
  </FormControl>
);

export default CurrencyPicker;
